import React from 'react'
// import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import product_logo from '../assets/images/doktrak_logo.png'
import favicon16 from "../assets/images/favicon16.png";
import favicon32 from "../assets/images/favicon32.png";
import favicon64 from "../assets/images/favicon64.png";

const mailToLink = 'mailto:sales@rekon.com?Subject=Rekon%20Website%3A%20Requesting%20Software%20Demonstration'

const DokTrakPage = () => (
  <div>
    <Helmet
      title="DokTrak"
      meta={[
        { name: 'description', content: 'DokTrak: Servicers\' most versatile and comprehensive document management and tracking technology.' }
      ]}
       link={[
        { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon16}` },
        { rel: "icon", type: "image/png", sizes: "32x32", href: `${favicon32}` },
        { rel: "shortcut icon", type: "image/png", href: `${favicon64}` },
       ]}
    />
    <div className="hero hero-product hero-doktrak is-medium">
      <div className="hero-body">
        <div className="container has-text-centered">
          <img src={product_logo} alt="DokTrak logo" className="product-logo"/>
          <h1 className="title">The Ultimate Document Management Solution</h1>
          <p>DokTrak empowers servicers of all sizes to regain control of their loan documents and files with a single technology solution.</p>
        </div>
      </div>
    </div>
    <section className="section product-features">
      <div className="container">
        <h2 className="title has-text-centered">With DokTrak, knowledge and control are yours, all the time:</h2>
        <div className="features-list-container columns is-mobile is-multiline">
          <div className="column is-full-mobile is-4-desktop">
            <ul>
              <li>Track any file or document, <strong>anywhere</strong>, at <strong>any time</strong></li>
              <li><strong>Quickly</strong> generate document and file barcode labels</li>
              <li><strong>Effectively</strong> identify and resolve all exceptions</li>
            </ul>
          </div>
          <div className="column is-full-mobile is-5-desktop">
            <ul>
                <li><strong>Efficiently process</strong> certification of pools and loan files</li>
                <li><strong>Improve</strong> the foreclosure paperwork process</li>
                <li>Lower <strong>retrieval cost</strong> and <strong>turnaround time</strong></li>
                <li><strong>Automate</strong> custodian document reconciliations</li>
              </ul>
          </div>
          <div className="column is-full-mobile is-3-desktop">
            <ul>
              <li><strong>Manage</strong> files and documents requests </li>
              <li><strong>Store and update</strong> loan data</li>
              <li>Create <strong>customized reports</strong></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section className="section product-promo">
      <div className="has-text-centered">
        <span className="title fg-grey block">
          You need to get it right.
        </span>
        <span className="title fg-success block">
          DokTrak makes it happen.
        </span>
      </div>
    </section>
    <section className="core-features">
      <div className="section container has-text-centered">
        <h2 className="title">Regain Control of Your Documents</h2>
        <p>DokTrak enables servicers to master document administration throughout the entire servicing life cycle.</p>
        <div className="columns core-features-columns">
          <div className="column">
            <h3 className="title">
              <i className="has-icon icon-folder"></i>
              <span className="is-centered">Total File <br/> Access</span>
            </h3>
            <p>
              DokTrak tracks the exact location of every document and every file, whether it’s with a custodian, at an off-site location, or in your own file room—right down to the row, bin, shelf or even box—all with just a few clicks.
            </p>
          </div>
          <div className="column">
            <h3 className="title">
              <i className="has-icon icon-deficiencies"></i>
              <span className="is-centered">Eliminate Deficiencies</span>
            </h3>
            <p>
              DokTrak quickly identifies post-closing deficiencies, manages exception resolution, and ensures compliance with ease.
            </p>
          </div>
          <div className="column">
            <h3 className="title">
              <i className="has-icon icon-streamline"></i>
              <span className="is-centered">Streamline Document Requests</span>
            </h3>
            <p>
              Order, track, and retrieve all document requests with a few mouse clicks on a single software platform. 
            </p>
          </div>
        </div>
      </div>
    </section>
    <section className="hero has-border"></section>
    <section className="section container-cta has-text-centered">
      <h2 className="title fg-success">With DokTrak, document control is finally possible.</h2>
      <p>See why DokTrak is the servicing industry’s most comprehensive document management and tracking solution.</p>
      <button onClick={() => window.location.href = mailToLink} className="button is-primary is-large" aria-label="Request a Demo of our Software">Schedule a demo today</button>
    </section>
  </div>
)

export default DokTrakPage



// WEBPACK FOOTER //
// ./src/pages/doktrak.js